import { t } from "@lingui/macro";
import { Sparkle } from "@phosphor-icons/react";
import { Switch } from "@reactive-resume/ui";

type Props = {
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
};

export const EnrichToggle = ({ value, disabled, onChange }: Props) => (
  <label className="flex min-w-0 cursor-pointer items-center gap-2.5">
    <Switch checked={value} disabled={disabled} onCheckedChange={onChange} />
    <span className="text-[13px] font-medium leading-snug text-foreground">
      <Sparkle size={13} weight="fill" className="mr-1 inline -translate-y-px text-primary" />
      {t`Write a complete first draft from my jobs`}
    </span>
  </label>
);
